<template>
  <div>
    <div class="section-header">
      <h1>Pending Invitations</h1>
    </div>
    <div v-if="invitations.length == 0">You have no pending invitations</div>
    <div class="card card--white small-top" v-for="invitation in invitations" :key="invitation.id">
      <div class="card--container">
        <div class="card-header">
          <div class="card-text-header">{{ invitation.first_name }} {{ invitation.last_name }}</div>
          <button flat small color="red" @click="destroy(invitation)"><h-icon>delete</h-icon></button>
        </div>
        <div>Email: {{invitation.email}}</div>
        <div>Invitation Link: {{ invitation.link }}</div>
        <h-btn :right='true' flat small color="primary" @click="mailTo(invitation)">Send Custom Invitation</h-btn>
        <h-btn :right='true' flat small color='secondary' @click="resendInvitation(invitation)">Resend from server</h-btn>
      </div>
    </div>
  </div>
</template>

<script>
import dataStore from "@/services/api/store";
import User from "@/services/api/authUser";
import axios from "axios";
import store from "@/services/api/store";

const STORE_CLIENT_INVITATION = "CoachClientInvitation";


export default {
  data() {
    return {
      invitations: [],

    };
  },
  created() {
    store   
      .findAll(STORE_CLIENT_INVITATION, {}, { force: true })
      .then(invitations => {
        this.invitations = invitations;
      });

  },
  methods: {
    mailTo(invitation) {
      const email = invitation.email;
      const subject = "HabitTechnology Invitation";
      let emailBody = `
      Hi ${invitation.first_name},

      Follow this url to join Habit Technology ${invitation.link}

      Thank you!
      ${User.first_name} ${User.last_name}
      `;
      emailBody = encodeURIComponent(emailBody);
      document.location = `mailto:${email}?subject=${subject}&body=${emailBody}`;
    },
    resendInvitation(invitation) {
      axios
        .get(
          `${process.env.VUE_APP_API_URL}coaches/client-invitations/${
            invitation.token
          }/resend_invitation/`
        )
        .then(() => {
          this.$emit("displaySnackbar", "Email sent");
        });
    },
    destroy(invitation) {
      dataStore.destroy(STORE_CLIENT_INVITATION, invitation.token).then(() => {
        this.$emit("displaySnackbar", "Deleted");
        this.invitations = this.invitations.filter(i => i.id !== invitation.id);
      });
    }
  }
};
</script>

<style>
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
